export default "__VITE_ASSET__BbJOE8KH__"